import {
    mapGetters,
    mapActions,
    mapMutations
  } from 'vuex'
  
  import * as supportStore from '@/store/support'
  
  export {
    supportStore
  }
  
  /**
     * Search store.
     *
     * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
     */
  export const createSupportStoreMixin = (without = []) => {
    const actions = !without.includes('actions') ? mapActions(supportStore.moduleName, Object.keys(supportStore.actionTypes)) : {}
    const getters = !without.includes('getters') ? mapGetters(supportStore.moduleName, Object.keys(supportStore.getterTypes)) : {}
    const mutations = !without.includes('mutations') ? mapMutations(supportStore.moduleName, Object.keys(supportStore.mutationTypes)) : {}
  
    return {
      methods: {
        ...actions,
        ...mutations
      },
      computed: {
        ...getters
      }
    }
  }
  